import useDataGridServerPagination from 'hooks/Shared/useDataGridServerPagination'
import {
  ICFDIsZIPUploadDetail,
  TCFDIsZIPUploadCategories,
} from 'models/invoices.models'
import { ICFDIsZIPUploadDetailsFiltersRequest } from 'services/Invoices/invoices.models'
import { getCFDIsZIPUploadDetails } from 'services/Invoices/invoices.services'

const useGetCFDIsZIPUploadDetails = (
  category: TCFDIsZIPUploadCategories,
  workspaceId: string | null,
  jobId: string | null
) => {
  const filters: ICFDIsZIPUploadDetailsFiltersRequest = {
    category,
    jobId,
  }

  const castedWorkspaceId = !workspaceId ? 0 : Number(workspaceId)

  return useDataGridServerPagination<
    ICFDIsZIPUploadDetail,
    ICFDIsZIPUploadDetailsFiltersRequest
  >({
    activeWorkspace: castedWorkspaceId,
    fetchFunction: getCFDIsZIPUploadDetails,
    pageSize: 10,
    withFilters: true,
    filters,
    enabled: !!(workspaceId && jobId),
  })
}

export default useGetCFDIsZIPUploadDetails
